import React from "react"

const PolicyIcon = props => {
    return (
        <svg 
            width={props.width} 
            height={props.height}
            viewBox="-0.5 -0.5 16 16" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M11.748812500000001 7.1733125V3.0890625c0 -0.104 -0.04125 -0.20368750000000002 -0.11475 -0.27718750000000003l-2.057125 -2.0570625000000002c-0.0735 -0.0735 -0.1731875 -0.1148125 -0.277125 -0.1148125H1.6875c-0.2165 0 -0.392 0.1755 -0.392 0.392v12.2826875c0 0.2165 0.1755 0.392 0.392 0.392h5.4879999999999995" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
            <path d="M3.9088125000000002 5.866687499999999h5.226687500000001M3.9088125000000002 3.2533125000000003h2.613375M3.9088125000000002 8.48h1.96" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
            <path d="M9.1355 0.64v2.2213125c0 0.2165 0.1755 0.392 0.392 0.392h2.2213125" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
            <path d="m11.743812499999999 9.215 1.6694999999999998 0.424c0.1738125 0.0441875 0.296375 0.20206249999999998 0.29100000000000004 0.3813125 -0.1121875 3.7620625000000003 -2.282125 4.3396875 -2.282125 4.3396875s-2.17 -0.577625 -2.2821875 -4.3396875c-0.0053125 -0.1791875 0.11725 -0.337125 0.29100000000000004 -0.3813125l1.6695625 -0.424c0.2110625 -0.0535625 0.432125 -0.0535625 0.6432499999999999 0Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
        </svg>
    )
}

export default PolicyIcon
